import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class QueryStringUtility {
    fetchQueryParameterValue(queryParameterName: string) {
        return this.fetchQueryParameterFromString(
            window.location.href,
            queryParameterName
        );
    }

    fetchHashParameterValue(queryParameterName: string) {
        return this.fetchHashParameterFromString(
            window.location.href,
            queryParameterName
        );
    }

    fetchQueryParameterFromString(
        stringToParse: string,
        queryParameterName: string
    ) {
        return this.fetchParameterValue(
            stringToParse,
            queryParameterName,
            '[?&]'
        );
    }

    fetchHashParameterFromString(
        stringToParse: string,
        queryParameterName: string
    ) {
        return this.fetchParameterValue(
            stringToParse,
            queryParameterName,
            '[#]'
        );
    }

    setAndReload(
        keyValuePairs: {
            key: string;
            value: string;
        }[]
    ) {
        const qs = this.queryStringToObject();
        keyValuePairs.forEach((keyValue) => {
            qs[keyValue.key] = keyValue.value;
        });
        document.location.search = this.objectToQueryString(qs);
    }

    private fetchParameterValue(
        stringToParse: string,
        queryParameterName: string,
        startToken: string
    ) {
        // 4/14/2021 - removed |&|#|$ from the end of this REGEX  - meaning =([^&#]*)|&|#|$ became =([^&#]*)
        // because it seemed to be unnecessary and was breaking auto login
        const regex = new RegExp(startToken + queryParameterName + '=([^&#]*)');
        const results = regex.exec(stringToParse);
        if (results && results[1]) {
            return results[1].replace(/\+/g, ' ');
        }
        return '';
    }

    private queryStringToObject(): {
        [key: string]: string;
    } {
        const returnObject: {
            [key: string]: string;
        } = {};
        document.location.search
            .substr(1)
            .split('&')
            .forEach((valueSet) => {
                const x = valueSet.split('=');
                if (x[0]) {
                    returnObject[decodeURIComponent(x[0])] = decodeURIComponent(
                        x[1]
                    );
                }
            });
        return returnObject;
    }

    private objectToQueryString(obj: { [key: string]: string }): string {
        const queryStringArray = [];
        for (const name in obj) {
            queryStringArray.push(
                `${encodeURIComponent(name)}=${encodeURIComponent(obj[name])}`
            );
        }
        return queryStringArray.join('&');
    }
}
